/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.19/esri/copyright.txt for details.
*/
const a="20210506",c="b02ca94fa7b6dac5fa148245a7cdc7caae582829";export{a as buildDate,c as commitHash};
